import { createContext, useContext, useState, useEffect, ReactNode } from "react"

type ColorMode = "light" | "dark"

interface ColorModeContextType {
  colorMode: ColorMode
  toggleColorMode: () => void
}

const ColorModeContext = createContext<ColorModeContextType>({
  colorMode: "light",
  toggleColorMode: () => {},
})

export const ColorModeProvider = ({ children }: { children: ReactNode }) => {
  const [colorMode, setColorMode] = useState<ColorMode>(() => {
    const stored = localStorage.getItem("chakra-color-mode")
    return (stored === "dark" ? "dark" : "light") as ColorMode
  })

  useEffect(() => {
    localStorage.setItem("chakra-color-mode", colorMode)
    const targets = [document.documentElement, document.body]
    targets.forEach((el) => {
      el.classList.remove("light", "dark")
      el.classList.add("chakra-theme", colorMode)
      el.style.colorScheme = colorMode
    })
  }, [colorMode])

  const toggleColorMode = () => {
    setColorMode((prev) => (prev === "light" ? "dark" : "light"))
  }

  return (
    <ColorModeContext.Provider value={{ colorMode, toggleColorMode }}>
      {children}
    </ColorModeContext.Provider>
  )
}

export const useColorMode = () => useContext(ColorModeContext)
